import React from "react";
import Button from "../button";
import Popover from "../popover";
import PopoverMenuContent from "../popover-menu-content";

// Filled button with a caret that opens a menu of `options` (PopoverMenuContent items).
const PopoverMenuButton = ({ label, options = [], className = "" }) => (
    <Popover
        placement="bottom"
        align="end"
        hideArrow
        content={<PopoverMenuContent items={options} />}
    >
        <Button className={`popover-menu-button ${className}`.trim()} type="secondary">
            <span className="popover-menu-button-label">{label}</span>
            <img className="popover-menu-button-caret" src="/images/icon/down-arrow-white.svg" alt="open" />
        </Button>
    </Popover>
);

export default PopoverMenuButton;
